import React from 'react';
import { MappingRow } from './MappingRow';
import { processData } from '../../../../common/utils/rest_utils';

export const MappingForm = ({ mapping, setMapping, collection, collections, pageContent }) => {
  const createNewParamRow = (rowObj) => {
    const newMapping = processData(mapping, rowObj);
    setMapping(newMapping);
  };

  return (
    <div className="table">
      <table className="table table-sm table-bordered table-condensed">
        <thead style={{ fontWeight: 'bold' }}>
          <tr>
            <td className="text-left">Field</td>
            <td className="text-left">Component</td>
          </tr>
        </thead>
        <tbody>
          {mapping.map((row, index) => (
            <MappingRow
              key={index}
              row={row}
              createNewParamRow={createNewParamRow}
              collection={collection}
              collections={collections}
              pageContent={pageContent}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
